
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/institutions",
      function () {
        return require("private-next-pages/institutions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/institutions"])
      });
    }
  